import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import apiConfig from '../constants/apiConfig';

export const useHealthCheck = (enabled: boolean) => {
  return useQuery({
    queryKey: ['healthCheck'],
    queryFn: async () => {
      const response = await axios.get<{ status: string; platform: string }>(
        apiConfig.apiGateway.comsHealthCheck
      );
      return response.data;
    },
    enabled: enabled,
  });
};
